import { toPreview } from '@/utils/fileUtil'

const undef = undefined

// 版权信息
const albumCopyright = {
  cpCompany: null,
}

// 付费信息
const albumPayment = {
  preSaleBegin: undef,
  paymentBegin: undef,
  paymentEnd: undef,
  price: 0,
}

export default class Album {
  constructor(initObj = {}) {
    const singerList = []
    let albumPhotoList = []
    let albumLicenseList = []
    const ac = { ...albumCopyright, ...initObj.albumCopyright }
    const ap = { ...albumPayment, ...initObj.albumPayment }

    // 艺人
    if (initObj.albumSingerList) {
      initObj.albumSingerList.forEach(singer => {
        // 如果是库外艺人, 不显示 id
        const value = singer.isOfficial ? `${singer.singerName}` : singer.singerName
        singerList.push({
          ...singer,
          id: singer.id,
          value,
          label: value,
        })
      })
    }

    // 图片
    if (initObj.albumPhotoList) {
      albumPhotoList = initObj.albumPhotoList.map(photo => {
        return {
          ...photo,
          url: toPreview(photo.photoUrl),
        }
      })
    }
    if (initObj.albumLicenseList) {
      albumLicenseList = initObj.albumLicenseList.map(license => {
        return {
          ...license,
          name: license.fileName,
          url: toPreview(license.licenseUrl),
        }
      })
    }

    this.albumId = initObj.albumId || ''
    // this.srcAlbumId = initObj.srcAlbumId ? initObj.srcAlbumId : ''
    this.srcAlbumName = initObj.srcAlbumName || ''
    this.albumName = initObj.albumName || ''
    this.transName = initObj.transName || ''
    this.otherName = initObj.otherName || ''
    this.albumDesc = initObj.albumDesc || ''
    this.albumSingerList = singerList
    this.publicCompany = initObj.publicCompany
    this.displayCompanyName = initObj.displayCompanyName || ''
    this.area = initObj.hasOwnProperty('area') ? initObj.area : 0
    this.type = initObj.type || 0
    this.isDigital = initObj.isDigital || 0
    this.genre = initObj.genre || ''
    // this.srcGenre = initObj.srcGenre ? initObj.srcGenre.split('|') : []
    this.version = initObj.version || 0
    this.srcVersion = initObj.srcVersion || ''
    this.language = initObj.language ? initObj.language.split(',').map(item => +item) : []
    this.upc = initObj.upc || ''
    this.status = initObj.status != null ? initObj.status : 0
    this.publicTime = initObj.publicTime || ''
    this.saleTime = initObj.saleTime || ''
    this.createUser = initObj.createUser || ''
    this.copyrightCompanyId = initObj.copyrightCompanyId || null
    this.copyrightCompanyName = initObj.copyrightCompanyName || ''

    this.insertTime = initObj.insertTime ? initObj.insertTime : undef
    this.modifyTime = initObj.modifyTime ? initObj.modifyTime : undef

    this.albumCopyright = ac
    this.albumPayment = ap
    this.albumLicenseList = albumLicenseList
    this.albumPhotoList = albumPhotoList

    this.genre = initObj.genre ? initObj.genre.split(',').map(v => +v) : []
    this.subGenre = initObj.subGenre ? initObj.subGenre.split(',').map(v => +v) : []
    this.version = initObj.version != null ? +initObj.version : ''
    this.discNumber = initObj.discNumber || ''
    // this.albumTrackList = albumTrackList
  }
}
